import { IAdvancedFormConfig } from '~shared/modules/advanced-form/models/advanced-form.model';
import { REGULAR_TRANSLATIONS } from '~shared/constants/translations.constant';

export const PRIVATE_INFO_FORM_CONFIG: IAdvancedFormConfig = {
  formSectionList: [
    {
      fieldList: [
        {
          name: 'firstName',
          label: 'REGULAR.FIELDS.FIRST_NAME.LABEL',
          hasRequiredMark: false,
        },
        {
          name: 'lastName',
          label: 'REGULAR.FIELDS.LAST_NAME.LABEL',
          hasRequiredMark: false,
        },
      ],
    }
  ],
  actionList: [
    {
      type: 'submit',
      text: REGULAR_TRANSLATIONS.save,
    },
  ],
};
